import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';

import { Button, Grid, Typography, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { TextValidator } from 'react-material-ui-form-validator';
import moment from 'moment';

import TableGeneric from '../../compartidos/abms/TableGeneric';

export const AsientosContablesSelect = ({formValues, restoCuenta, setRestoCuenta,...props}) => {
    const { setearVariosValores } = props;
    const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);
    const componentRef = useRef();

    const [open, setOpen] = useState(false);
    const [idTomado, setIdTomado] = useState("");

    return (
        <>
            {open && (
                <Modal 
                    id={idTomado} 
                    setId={setIdTomado} 
                    open={open} 
                    setOpen={setOpen} 
                    setearValor={setearVariosValores} 
                    formValues={formValues} 
                    setRestoCuenta={setRestoCuenta} 
                    restoCuenta={restoCuenta}
                />
            )}
            <Grid container direction='column' justify='flex-start'>
                <Typography variant='button' style={{marginRight: "1em"}}>
                    Valor del importe total: {formValues.totalComprobante}$ - 
                    <span style={parseInt(restoCuenta) !== 0 ? {color: "red"} : {color: "green"}}> Resto: {restoCuenta}$</span>
                </Typography>
                <TableGeneric
                    ref={componentRef}
                    data={cuentas}
                    withoutPagination
                    align="center"
                    columns={[
                        {
                            label: "Cuenta",
                            id: "cuenta",
                        },
                        {
                            label: "Subcuenta",
                            id: "subCuenta",
                        },
                        {
                            label: "Descripcion",
                            id: "descripcion",
                        },
                        {
                            label: "Fecha Alta",
                            id: "fechaAlta",
                            customBody: (item) => moment(item.fechaAlta).format("DD/MM/YYYY"),
                        },
                        {
                            id: "id",
                            customBody: (item) => 
                                !formValues.cuentasContables.find(cuenta => cuenta.idCuentaContable === item.id)?.asignada ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        disabled={restoCuenta <= 0}
                                        onClick={() => {
                                            setIdTomado(item.id);
                                            setOpen(true);
                                        }}
                                    >
                                        ASIGNAR CUENTA
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        onClick={() => {
                                            setearVariosValores({
                                                ...formValues,
                                                cuentasContables: formValues.cuentasContables.map(cuenta => (
                                                    cuenta.idCuentaContable === item.id
                                                    ? {
                                                        idCuentaContable: item.id,
                                                        importeCuenta: 0,
                                                        asignada: false
                                                    } : cuenta
                                                ))
                                            });
                                            const importe = formValues.cuentasContables.find(c => c.idCuentaContable === item.id).importeCuenta;
                                            const resultadoCuenta = parseFloat(restoCuenta) + parseFloat(importe)
                                            setRestoCuenta(resultadoCuenta.toFixed(2));
                                        }}
                                    >
                                        DESELECCIONAR CUENTA
                                    </Button>
                                ),
                        },
                        {
                            id: "id",
                            customBody: (item) => (
                                <Typography variant='caption'>
                                    Importe de la Cuenta: {formValues.cuentasContables.find(cuenta => cuenta.idCuentaContable === item.id).importeCuenta}$
                                </Typography>
                            ),
                        }
                    ]}
                />
            </Grid>
        </>
    )
}

const Modal = ({id, setId, open, setOpen, setearValor, formValues, setRestoCuenta, restoCuenta}) => {
    const [importe, setImporte] = useState("");

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth={"md"}>
            <DialogTitle id="alert-dialog-slide-title" style={{background: '#9C27B0', color: 'white'}}>Asignar importe a la cuenta contable</DialogTitle>
            <DialogContent>
                <Grid container justify='center'>
                    <Grid item xs={12}>
                        <TextValidator
                            variant="outlined"
                            margin='normal'
                            fullWidth
                            label="Importe Cuenta"
                            autoComplete="off"
                            type="number"
                            value={importe} 
                            onChange={e => {
                                setImporte(e.target.value);
                            }}
                            InputLabelProps={{ style: { fontWeight: 'bold' } }}
                        />
                    </Grid>
                    <Grid item xs={12} style={{display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1em", marginTop: "1em"}}>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                                setImporte("");
                                setId("");
                            }}
                        >
                            CERRAR
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                                setearValor({
                                    ...formValues,
                                    cuentasContables: formValues.cuentasContables.map(item => (
                                        item.idCuentaContable === id
                                        ? {
                                            idCuentaContable: id,
                                            importeCuenta: parseFloat(importe).toFixed(2),
                                            asignada: true
                                        } : item
                                    ))
                                });
                                const resultadoCuenta = parseFloat(restoCuenta) - parseFloat(importe);
                                setRestoCuenta(resultadoCuenta.toFixed(2))
                                setOpen(false);
                                setId("");
                            }}
                        >
                            ASIGNAR IMPORTE
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}